import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import type { WizardStepProps } from 'modules/engagement_surveys/components/SurveyWizard/types'

export function EditorsStep({ data, errors, onDataChanged }: WizardStepProps) {
  return (
    <Box gap="s32" gapDivider>
      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.editors.title')}
        </Text.Header2>

        <EmployeeSelector
          label={i18n.t('surveys.configuration.editors.label')}
          value={data.editors}
          withAvatar
          excludeCurrentEmployee
          multiple
          hideSearchIcon
          onSelect={(employees) => {
            onDataChanged({ ...data, editors: employees })
          }}
          error={Array.isArray(errors.editors) ? String(errors.editors[0]) : errors.editors}
        />
      </Box>

      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.visibility.title')}
        </Text.Header2>

        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                onChange={() =>
                  onDataChanged({
                    ...data,
                    restrictedViewersEnabled: !data.restrictedViewersEnabled,
                  })
                }
                value={data.restrictedViewersEnabled}
              />
            }
          >
            {i18n.t('surveys.configuration.visibility.restricted_viewers.label')}
          </Card.Title>
          <Card.Description>
            {i18n.t('surveys.configuration.visibility.restricted_viewers.description')}
          </Card.Description>
        </Card>
      </Box>
    </Box>
  )
}
